import React, { useState, useEffect } from 'react';
import './FormModal.css';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import api from '../../api';
import Swal from 'sweetalert2';
import { Grid, TextField, Box, Button, Dialog, DialogTitle, Tooltip,DialogContent, DialogActions, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { FiPlus } from 'react-icons/fi';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { motion } from 'framer-motion';
import SubjectModal from './SubjectList/SubjectModal';
import TopicModal from './TopicList/TopicModal';
// import * as XLSX from 'xlsx';
import CreatableSelect from 'react-select/creatable';
import ExcelJS from 'exceljs';


const FormModalBulk = ({ onClose }) => {
const [loading, setLoading] = useState(false); // ✅ Added loading state
const [errors, setErrors] = useState([]);

// Paper Set Requirement
const [selectedExam, setSelectedExam] = useState('');
const [selectedSubject, setSelectedSubject] = useState('');
const [selectedTopic, setSelectedTopic] = useState('');

  // Modal open states
  const [addExamModalOpen, setAddExamModalOpen] = useState(false);
  const [newExam, setNewExam] = useState({
    title: '',
    duration_minutes: '10',
    total_marks: '10',
    passing_marks: '10',
    //status: 'Active',
    status: true, //  boolean
    exam_type: 'practice'
  });

  const [addSubjectModalOpen, setAddSubjectModalOpen] = useState(false);
  const [newSubjectData, setNewSubjectData] = useState({
    exam_id: '',
    name: '',
    code: '',
    status: 'Active'
  });
  const [codeManuallyEdited, setCodeManuallyEdited] = useState(false);

  const [addTopicModalOpen, setAddTopicModalOpen] = useState(false);
  const [newTopic, setNewTopic] = useState({
    exam_id: '',
    subject_id: '',
    title: '',
    status: 1
  });

  //to track selected files 
  const [selectedFile, setSelectedFile] = useState(null);

  const [newExamAddedId, setNewExamAddedId] = useState(null);

  const [uploadProgress, setUploadProgress] = useState(0);


 // Clear Filters function
const clearFilters = () => {
        setSelectedExam("");
        setSelectedSubject("");
        setSelectedTopic("");
};

  useEffect(() => {
    const header = document.querySelector('.dashboard-header');

    if (window.innerWidth <= 768 && header) {
      header.style.display = 'none';
    }

    return () => {
      if (header) header.style.display = '';
    };
  }, []);

  const handleAddExamSubmit = async () => {
    const trimmedTitle = newExam.title.trim();
    if (!trimmedTitle) {
      Swal.fire({ icon: "warning", title: "Missing Title", text: "Enter exam title" });
      return;
    }

    // 🔍 Prevent duplicates
    const duplicate = exams.find(
      exam => typeof exam.title === "string" && exam.title.toLowerCase() === trimmedTitle.toLowerCase()
    );
    if (duplicate) {
      Swal.fire({ icon: "warning", title: "Duplicate", text: "Exam already exists" });
      return;
    }

    try {
      // ✅ Step 1: Add new exam
      const response = await api.post("/exams", newExam);
      if (response.status === 200 || response.status === 201) {
        // ✅ Step 2: Re-fetch the updated list from backend
        const updatedRes = await api.get("/exams");
        const updatedExams = updatedRes.data;
        setExams(updatedExams);

        // ✅ Step 3: Find the newly added exam (by title or id)
        const newExamObj =
          updatedExams.find(ex => ex.id === response.data.id) ||
          updatedExams.find(ex => ex.title.toLowerCase() === trimmedTitle.toLowerCase());

        if (newExamObj) {
          setSelectedExam(String(newExamObj.id));
          setSelectedExamObj(newExamObj);
        }

        // ✅ Step 4: Reset dependent dropdowns
        setSelectedSubject("");
        setSelectedTopic("");
        setSubjects([]);
        setTopics([]);

        // ✅ Step 5: Close modal & reset form
        setAddExamModalOpen(false);
        setNewExam({
          title: "",
          duration_minutes: "",
          total_marks: "",
          passing_marks: "",
          status: true,
          exam_type: "",
        });

        Swal.fire({
          icon: "success",
          title: "Exam Added & Selected!",
          timer: 1500,
          showConfirmButton: false,
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Failed to add exam",
      });
    }
  };




  const [modalOpen, setModalOpen] = useState(false);
 
  // Trigger CSV upload input
  const handleBulkUpload = () => {
    document.getElementById('csv-upload')?.click();
    toast.info("Select a CSV file to bulk upload questions.");
  };

  // Upload CSV
  // Handle CSV file upload
  // CSV Upload
  const handleCsvUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const fileExtension = file.name.split('.').pop().toLowerCase();
    const allowedExtensions = ['csv', 'xls', 'xlsx']; // ✅ Allow CSV and Excel

    if (!allowedExtensions.includes(fileExtension)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid File Type',
        text: 'Only CSV or Excel files are allowed. Please select a valid file.',
        confirmButtonColor: '#d33',
      });
      e.target.value = ''; // Reset input
      return;
    }

    const confirmResult = await Swal.fire({
      title: 'Are you sure?',
      text: `You are about to upload the file: ${file.name}`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Yes, upload it!',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    });

    if (!confirmResult.isConfirmed) return;

    Swal.fire({
      title: 'Uploading...',
      text: 'Please wait while we upload and process the file.',
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });

    const formData = new FormData();
    formData.append('file', file);
    formData.append('exam_id', selectedExam);
    formData.append('subject_id', selectedSubject);
    formData.append('topic_id', selectedTopic ? parseInt(selectedTopic) : null);
    // ✅ Only append topic_id if it's actually selected
    if (selectedTopic && selectedTopic !== "null" && selectedTopic !== "") {
      formData.append("topic_id", selectedTopic);
    }
    // log payload for debugging
    console.log("📤 FormData payload:");
    for (let pair of formData.entries()) {
      console.log(pair[0] + ":", pair[1]);
    }


    try {
      console.log('Uploading file with IDs:', {
        exam_id: selectedExam,
        subject_id: selectedSubject,
        topic_id: selectedTopic,
        fileName: file.name
      });
      setLoading(true);
      const result = await api.post('/questions/bulk-upload', formData);

      Swal.fire({
        icon: 'success',
        title: 'Upload Successful!',
        text: result.data.message || 'Questions have been uploaded successfully.',
        confirmButtonColor: '#3085d6',
      });

      setErrors([]);
      e.target.value = ''; // Reset input
    } catch (error) {
      console.error('Upload error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: error.response?.data?.message || 'Something went wrong. Please check your file format.',
        confirmButtonColor: '#d33',
      });

      if (error.response?.data?.errors) setErrors(error.response.data.errors);
    } finally {
      setLoading(false);
    }
  };

  // const handleCsvUploadWrapper = async () => {
  //   if (!selectedFile) return;

  //   // ✅ Make sure selectedExam and selectedSubject are valid
  //   if (!selectedExam) {
  //     Swal.fire('Error', 'Please select an exam first', 'warning');
  //     return;
  //   }

  //   const formData = new FormData();
  //   formData.append('file', selectedFile);
  //   formData.append('exam_id', selectedExam);
  //   if (selectedSubject) formData.append('subject_id', selectedSubject);
  //   if (selectedTopic) formData.append('topic_id', selectedTopic);

  //   try {
  //     Swal.fire({
  //       title: 'Uploading...',
  //       text: 'Please wait while we upload and process the file.',
  //       allowOutsideClick: false,
  //       didOpen: () => Swal.showLoading(),
  //     });

  //     const result = await api.post('/questions/bulk-upload', formData);

  //     Swal.fire({
  //       icon: 'success',
  //       title: 'Upload Successful!',
  //       text: result.data.message || 'Questions have been uploaded successfully.',
  //     });

  //     setErrors([]);
  //     setSelectedFile(null);
  //   } catch (error) {
  //     console.error('Upload error:', error);
  //     Swal.fire({
  //       icon: 'error',
  //       title: 'Upload Failed',
  //       text: error.response?.data?.message || 'Something went wrong. Please check your file format.',
  //     });

  //     if (error.response?.data?.errors) setErrors(error.response.data.errors);
  //   }
  // };



  // Export existing questions as CSV
  // Export CSV
 
  const handleCsvUploadWrapper = async () => {
    if (!selectedFile) return;

    if (!selectedExam) {
      Swal.fire('Error', 'Please select an exam first', 'warning');
      return;
    }

    const formData = new FormData();
    formData.append('file', selectedFile);
    formData.append('exam_id', selectedExam);
    if (selectedSubject) formData.append('subject_id', selectedSubject);
    if (selectedTopic) formData.append('topic_id', selectedTopic);

    try {
      setUploadProgress(0); // reset progress
      // Optionally remove Swal loading for real-time progress UI
      // Swal.fire({ title: 'Uploading...', text: 'Please wait...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });

      const result = await api.post('/questions/bulk-upload', formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        },
      });

      // Show success popup after upload completes
      Swal.fire({
        icon: 'success',
        title: 'Upload Successful!',
        text: result.data.message || 'Questions have been uploaded successfully.',
      });

      setErrors([]);
      setSelectedFile(null);
      setUploadProgress(0); // reset progress after success
    } catch (error) {
      console.error('Upload error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Upload Failed',
        text: error.response?.data?.message || 'Something went wrong. Please check your file format.',
      });

      if (error.response?.data?.errors) setErrors(error.response.data.errors);
      setUploadProgress(0); // reset progress on error
    }
  };

 
  const handleExportCSV = async () => {
    Swal.fire({
      title: 'Exporting CSV...',
      text: 'Please wait while we generate your file.',
      allowOutsideClick: false,
      allowEscapeKey: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      const response = await api.get('/questions/export', { responseType: 'blob' });
      // ✅ Changed: removed `response.ok` (Axios does not have it)

      const blob = response.data;
      // ✅ Changed: use `response.data` directly, already a blob
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'questions.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();

      Swal.fire({
        icon: 'success',
        title: 'Export Complete',
        text: 'Your CSV file has been downloaded.',
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.response?.data?.message || 'Unable to export questions. Try again later.',
      });
    }
  };


  const handleDownloadTemplate = () => {
    const url = '/sample_template.csv';
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'sample_template.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Show success alert
    Swal.fire({
      icon: 'success',
      title: 'Download Started...',
      text: 'Your CSV template is downloading!',
      timer: 2000,
      showConfirmButton: false
    });
  };

  // const handleDownloadExcelTemplate = () => {
  //   const url = '/question_template.xlsx';
  //   const link = document.createElement('a');
  //   link.href = url;
  //   link.setAttribute('download', 'question_template.xlsx');
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);

  //   // Show success alert
  //   Swal.fire({
  //     icon: 'success',
  //     title: 'Download Started...',
  //     text: 'Your Excel template is downloading!',
  //     timer: 2000,
  //     showConfirmButton: false
  //   });
  // };


  // const handleDownloadExcelTemplate = () => {
  //   const headers = [
  //     'question_text',
  //     'option_a',
  //     'option_b',
  //     'option_c',
  //     'option_d',
  //     'correct_option',
  //     'marks',
  //     'question_type',
  //     'question_level', // ✅ new column
  //   ];

  //   const ws = XLSX.utils.json_to_sheet([{}]); // blank sheet
  //   XLSX.utils.sheet_add_aoa(ws, [headers]); // add headers

  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, 'Questions');

  //   XLSX.writeFile(wb, 'question_template.xlsx');

  //   Swal.fire({
  //     icon: 'success',
  //     title: 'Download Started...',
  //     text: 'Your Excel template is downloading!',
  //     timer: 2000,
  //     showConfirmButton: false
  //   });
  // };


  const handleDownloadExcelTemplate = async () => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Questions');

  // ✅ Add header row
  const headers = [
    'question_text',
    'option_a',
    'option_b',
    'option_c',
    'option_d',
    'correct_option',
    'marks',
    'question_type',
    'question_level',
  ];
  worksheet.addRow(headers);

  // ✅ Format header
  worksheet.getRow(1).font = { bold: true };
  worksheet.columns = headers.map(h => ({ header: h, key: h, width: 20 }));

  // ✅ Generate file and trigger download
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = 'question_template.xlsx';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  Swal.fire({
    icon: 'success',
    title: 'Download Started...',
    text: 'Your Excel template is downloading!',
    timer: 2000,
    showConfirmButton: false
  });
};


  const [selectedExamObj, setSelectedExamObj] = useState(null);
  const [selectedSubjectObj, setSelectedSubjectObj] = useState(null);
  const [selectedTopicObj, setSelectedTopicObj] = useState(null);

  const [exams, setExams] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [topics, setTopics] = useState([]);

//fetch exams
  useEffect(() => {
   // axios.get(`${API_URL}/api/exams`)
   api.get('/exams')
      .then(res => setExams(res.data))
      .catch(err => console.error('Error fetching exams:', err));
  }, []);

  //fetch subjects
  useEffect(() => {
    if (selectedExam) {
     // axios.get(`${API_URL}/api/subjects?exam_id=${selectedExam}`)
     api.get(`/subjects?exam_id=${selectedExam}`)
        .then(res => setSubjects(res.data))
        .catch(err => console.error('Error fetching subjects:', err));
    } else {
      setSubjects([]);
    }
  }, [selectedExam]);

  //fetch topics
  useEffect(() => {
    if (selectedSubject) {
     // axios.get(`${API_URL}/api/topics?subject_id=${selectedSubject}`)
     api.get(`/topics?subject_id=${selectedSubject}`)
        .then(res => setTopics(res.data))
        .catch(err => console.error('Error fetching topics:', err));
    } else {
      setTopics([]);
    }
  }, [selectedSubject]);



  const handleAddSubject = async () => {
    if (!newSubjectData.exam_id || !newSubjectData.name.trim() || !newSubjectData.code.trim()) {
      Swal.fire('Error', 'Please fill all fields', 'warning');
      return;
    }

    // 🔍 Check for duplicates
    const codeExists = subjects.some(
      (sub) =>
        sub.exam_id === parseInt(newSubjectData.exam_id) &&
        sub.code.toLowerCase() === newSubjectData.code.toLowerCase()
    );

    const nameExists = subjects.some(
      (sub) =>
        sub.exam_id === parseInt(newSubjectData.exam_id) &&
        sub.name.toLowerCase() === newSubjectData.name.toLowerCase()
    );

    if (codeExists || nameExists) {
      Swal.fire('Duplicate Entry', 'Subject code or name already exists for this exam', 'warning');
      return;
    }

    try {
      const payload = {
        exam_id: parseInt(newSubjectData.exam_id),
        name: newSubjectData.name.trim(),
        code: newSubjectData.code.trim(),
        status: newSubjectData.status === 'Active' ? 1 : 0,
      };

      // ✅ 1. Add subject
      const res = await api.post('/subjects', payload);

      // ✅ 2. Fetch updated subjects for this exam
      const updatedRes = await api.get(`/subjects?exam_id=${newSubjectData.exam_id}`);
      const updatedSubjects = updatedRes.data || [];
      setSubjects(updatedSubjects);

      // ✅ 3. Find and preselect the newly added subject
      const addedSubject =
        updatedSubjects.find((sub) => sub.id === res.data.id) ||
        updatedSubjects.find(
          (sub) => sub.name.toLowerCase() === newSubjectData.name.toLowerCase()
        );

      if (addedSubject) {
        setSelectedSubject(String(addedSubject.id));
        setSelectedSubjectObj(addedSubject);
      }

      // ✅ 4. Reset and close modal
      setAddSubjectModalOpen(false);
      setNewSubjectData({ exam_id: '', name: '', code: '', status: 'Active' });

      // ✅ 5. Show success toast
      Swal.fire({
        icon: 'success',
        title: 'Subject Added & Selected!',
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error(err);
      Swal.fire('Error', err?.response?.data?.message || 'Failed to add subject', 'error');
    }
  };




const generateCode = (subjectName) => {
  if (!subjectName) return '';

  // Step 1: Create prefix from subject name (first letters, up to 4)
  const prefix = subjectName
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase()
    .substring(0, 4);

  // Step 2: Get current date and time parts
  const now = new Date();
  const year = now.getFullYear(); // e.g., 2025
  const month = String(now.getMonth() + 1).padStart(2, '0'); // 01–12
  const day = String(now.getDate()).padStart(2, '0'); // 01–31
  const hours = String(now.getHours()).padStart(2, '0'); // 00–23
  const minutes = String(now.getMinutes()).padStart(2, '0'); // 00–59
  const seconds = String(now.getSeconds()).padStart(2, '0'); // 00–59

  // Step 3: Combine everything
  const code = `${prefix}${year}${month}${day}${hours}${minutes}${seconds}`;

  return code;
};



  // ✅ Function for adding topic (auto-select + refresh + modal reset)
  const handleAddTopic = async () => {
    if (!newTopic.exam_id || !newTopic.subject_id || !newTopic.title.trim()) {
      Swal.fire('Error', 'Please fill all fields', 'warning');
      return;
    }

    try {
      const payload = {
        exam_id: parseInt(newTopic.exam_id),
        subject_id: parseInt(newTopic.subject_id),
        title: newTopic.title.trim(),
        status: newTopic.status,
      };

      // ✅ 1. Add topic
      const res = await api.post('/topics', payload);

      // ✅ 2. Fetch updated topics for this subject
      const updatedRes = await api.get(`/topics?subject_id=${newTopic.subject_id}`);
      const updatedTopics = updatedRes.data || [];
      setTopics(updatedTopics);

      // ✅ 3. Find and preselect newly added topic
      const newTopicObj =
        updatedTopics.find(t => t.id === res.data.id) ||
        updatedTopics.find(t => t.title.toLowerCase() === newTopic.title.toLowerCase());

      if (newTopicObj) {
        setSelectedTopic(String(newTopicObj.id));
        setSelectedTopicObj(newTopicObj);
      }

      // ✅ 4. Reset and close modal
      setAddTopicModalOpen(false);
      setNewTopic({ exam_id: '', subject_id: '', title: '', status: 1 });

      // ✅ 5. Show success toast
      Swal.fire({
        icon: 'success',
        title: 'Topic Added & Selected!',
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (err) {
      console.error(err);
      Swal.fire('Error', err?.response?.data?.message || 'Failed to add topic', 'error');
    }
  };

 



  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <button className="modal-close-icon" onClick={onClose}>&times;</button>

        <h2 className='bulk-upload-heading'>⬆️ Bulk Upload Questions</h2>

        {/* ⚠️ Important Note */}
        {/* <p className="admin-note">
          ⚠️ <strong>Note:</strong> You can download the templates below in <strong>CSV or Excel</strong> format
          and enter your questions and options in plain text. <br />
          Only <strong>text-based questions and answers</strong> are supported in bulk upload.
          Do not include images or formatting. Make sure all required fields are filled.
        </p> */}

        <div className="bulk-upload-template-section section-card">
  <h3>Download Excel Template</h3>
  <p className="template-note">
    📄 Please download this Excel template to prepare your questions before uploading. 
    Make sure to follow the format exactly for a smooth bulk upload.
  </p>
  <a
    href="#"
    onClick={(e) => {
      e.preventDefault();
      handleDownloadExcelTemplate();
    }}
    className="template-link"
  >
    ⬇️ Download Excel Template
  </a>
</div>


        {/* 📁 Upload CSV
        <input
          type="file"
          accept=".csv"
          onChange={handleCsvUpload}
          className="image-upload-input"
        />
        {loading && <div className="spinner"></div>} */}

       <div className="dropdown-section section-card">
        <h3 className="dropdown-section-heading">🎯 Select Exam, Subject & Topic</h3>
         <div style={{ display: 'flex', gap: '0.2rem', flexWrap: 'wrap', marginBottom: '1rem' }}>
          {/* Exam Dropdown with "Add New Exam" functionality */}
          <div style={{ flex: '1 1 250px' }}>
            <label>Select Exam (Required)</label>
            <CreatableSelect
              isClearable
              value={
                selectedExamObj
                  ? { value: selectedExamObj.id, label: selectedExamObj.title }
                  : null
              }
              onChange={(newValue, actionMeta) => {
                if (actionMeta.action === "create-option") {
                  // User typed a new exam name → open Add Exam modal
                  setNewExam({ ...newExam, title: newValue.label });
                  setAddExamModalOpen(true);
                } else if (newValue) {
                  // User selected an existing exam
                  const examObj = exams.find(ex => String(ex.id) === String(newValue.value));
                  setSelectedExam(String(examObj.id));
                  setSelectedExamObj(examObj);
                  setSelectedSubject("");
                  setSelectedTopic("");
                  setSubjects([]);
                  setTopics([]);
                } else {
                  // Cleared selection
                  setSelectedExam("");
                  setSelectedExamObj(null);
                  setSelectedSubject("");
                  setSelectedTopic("");
                  setSubjects([]);
                  setTopics([]);
                }
              }}
              options={exams.map(exam => ({ value: exam.id, label: exam.title }))}
              placeholder="Select or type exam..."
            />
          </div>

          {/* Subject Dropdown with that add new subject included in it  */}
          <div style={{ flex: '1 1 250px' }}>
            <label>Select Subject (Optional)</label>
            <CreatableSelect
              isClearable
              value={selectedSubject ? { value: selectedSubjectObj?.id, label: selectedSubjectObj?.name } : null}
              onChange={(newValue, actionMeta) => {
                if (actionMeta.action === 'create-option') {
                  // User typed something not found → open Add Subject modal
                  setNewSubjectData({
                    exam_id: selectedExam,
                    name: newValue.label,
                    code: generateCode(newValue.label)
                  });

                  setAddSubjectModalOpen(true);
                  setCodeManuallyEdited(false);
                } else if (newValue) {
                  // User selected an existing subject
                  const subjObj = subjects.find(sub => String(sub.id) === String(newValue.value));
                  setSelectedSubject(String(subjObj.id));
                  setSelectedSubjectObj(subjObj);
                  setSelectedTopic('');
                  setTopics([]);
                } else {
                  // Cleared selection
                  setSelectedSubject('');
                  setSelectedSubjectObj(null);
                  setSelectedTopic('');
                  setTopics([]);
                }
              }}
              options={subjects.map(sub => ({ value: sub.id, label: sub.name }))}
              placeholder="Select or type subject..."
              styles={{
                control: (provided) => ({ ...provided, borderColor: '#1976d2', borderRadius: '6px' }),
                menu: (provided) => ({ ...provided, borderRadius: '6px' }),
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: 'transparent', // removes light-blue highlight
                  primary: '#1976d2',
                },
              })}
            />
          </div>


          {/* Topic Dropdown with that add new topic included in it that add topic modal */}
          <div style={{ flex: '1 1 250px' }}>
            <label>Select Topic (Optional)</label>
            <CreatableSelect
              isClearable
              value={selectedTopic ? { value: selectedTopicObj?.id, label: selectedTopicObj?.title } : null}
              onChange={(newValue, actionMeta) => {
                if (actionMeta.action === 'create-option') {
                  // User typed something not found → open Add Topic modal
                  setNewTopic({ ...newTopic, title: newValue.label, exam_id: selectedExam, subject_id: selectedSubject });
                  setAddTopicModalOpen(true);
                } else if (newValue) {
                  // User selected an existing topic
                  const topicObj = topics.find(t => String(t.id) === String(newValue.value));
                  setSelectedTopic(String(topicObj.id));
                  setSelectedTopicObj(topicObj);
                } else {
                  // Cleared selection
                  setSelectedTopic('');
                  setSelectedTopicObj(null);
                }
              }}
              options={topics.map(t => ({ value: t.id, label: t.title }))}
              placeholder="Select or type topic..."
              styles={{
                control: (provided) => ({ ...provided, borderColor: '#1976d2', borderRadius: '6px' }),
                menu: (provided) => ({ ...provided, borderRadius: '6px' }),
              }}
              theme={(theme) => ({
                ...theme,
                colors: {
                  ...theme.colors,
                  primary25: 'transparent', // removes light-blue highlight
                  primary: '#1976d2',
                },
              })}
            />
          </div>
        </div>
       </div>

        {/* adding add exams add subject and add topic buttons */}
        <Box display="flex" gap="1rem" flexWrap="wrap" mb={2}>
          {/* Add Exam Button */}
          {/* <Tooltip title="Create a new exam and set its details" arrow>
            <Button
              variant="contained"
              color="primary"
              startIcon={<FiPlus />}
              onClick={() => setAddExamModalOpen(true)}
            >
              Add Exam
            </Button>
          </Tooltip> */}

          {/* Add Subject Button */}
          {/* <Tooltip title="Add a new subject under the selected exam" arrow>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<FiPlus />}
              onClick={() => {
                setAddSubjectModalOpen(true);
                setCodeManuallyEdited(false); // reset manual edit flag
              }}
            >
              Add Subject
            </Button>
          </Tooltip> */}

          {/* Add Topic Button */}
          {/* <Tooltip title="Add a new topic inside the selected subject" arrow>
            <Button
              variant="contained"
              color="success"
              startIcon={<FiPlus />}
              onClick={() => setAddTopicModalOpen(true)}
            >
              Add Topic
            </Button>
          </Tooltip> */}
        </Box>


        <div className="question-tools">
          {/* 📤 Trigger file input for CSV upload */}
          {/* <button
            type="button"
            onClick={handleBulkUpload}
            className="secondary-btn"
            title="Upload multiple questions from a CSV file"
          >
            🧾Choose a File For Bulk Upload
          </button> */}

          {/* 📥 Trigger CSV export */}
          {/* <button
            type="button"
            onClick={handleExportCSV}
            className="secondary-btn"
            title="Download existing questions as CSV"
          >
            📥 Export CSV
          </button> */}

          {/* Hidden input to trigger on button click */}
          {/* <input
            id="csv-upload"
            type="file"
            accept=".csv, .xls, .xlsx" //  Allow CSV and Excel files
            onChange={handleCsvUpload}
            style={{ display: 'none' }}
          /> */}
        </div>

        {/* 📤 Bulk Upload Section */}
<div className="bulk-upload-section section-card">
  <h3 className="section-heading">⬆️ Bulk Upload Questions</h3>

  <p className="bulk-upload-note">
    Upload your questions file (<b>.xls, .xlsx</b>). Select a file here and click <b>“Upload”</b>.
  </p>

  {/* Hidden file input */}
  <input
    id="csv-upload"
    type="file"
    accept=".csv, .xls, .xlsx"
    onChange={(e) => setSelectedFile(e.target.files[0] || null)}
    style={{ display: 'none' }}
  />

  {/* File Upload Box */}
  <div
    className={`file-drop-zone ${selectedFile ? 'file-selected' : ''}`}
    onClick={() => document.getElementById('csv-upload').click()}
    onDragOver={(e) => e.preventDefault()}
    onDrop={(e) => {
      e.preventDefault();
      if (e.dataTransfer.files[0]) setSelectedFile(e.dataTransfer.files[0]);
    }}
  >
    {selectedFile ? (
      <>
        <span className="file-name">📄 {selectedFile.name}</span>
        <button
          type="button"
          className="file-remove-btn"
          onClick={(e) => {
            e.stopPropagation();
            setSelectedFile(null);
          }}
        >
          ✕
        </button>
      </>
    ) : (
      <span className="file-placeholder">Click to choose a file to upload</span>
    )}
  </div>

  {/* Progress bar */}
  {uploadProgress > 0 && (
    <div className="progress-bar-container">
      <div
        className="progress-bar"
        style={{ width: `${uploadProgress}%` }}
      >
        {uploadProgress}%
      </div>
    </div>
  )}

  {/* Buttons */}
  <div className="upload-buttons">
    <button
      type="button"
      className="upload-btn"
      onClick={handleCsvUploadWrapper}
      disabled={!selectedFile}
    >
      Upload
    </button>

    <button
      type="button"
      className="cancel-btn"
      onClick={() => setSelectedFile(null)}
    >
      Cancel
    </button>
  </div>

  {/* Errors */}
  {errors.length > 0 && (
    <div className="error-box">
      <strong>Errors:</strong>
      <ul>
        {errors.map((err, i) => (
          <li key={i}>{err}</li>
        ))}
      </ul>
    </div>
  )}
</div>


        
        {/* ✅ Buttons */}
        {/* <div className="modal-buttons">
          <button type="button" onClick={onClose}>Close</button>
        </div> */}
      </div>

      {/* ✅ Toast container */}
      <ToastContainer
        position="bottom-right"
        autoClose={2500}
        theme="colored"
      />
      
      <Dialog
  open={addExamModalOpen}
  onClose={() => setAddExamModalOpen(false)}
  fullWidth
  maxWidth="xl"
  sx={{
    '& .MuiDialog-paper': {
      width: '100%',
      maxWidth: '900px', // or '100%' for full screen
      borderRadius: '12px',
    },
  }}
>
  <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      style={{
        fontWeight: "bold",
        fontSize: "1.4rem",
        color: "#1976d2",
        display: "flex",
        gap: "8px",
        alignItems: "center"
      }}
    >
      📝 Add New Exam
    </motion.div>
    <IconButton onClick={() => setAddExamModalOpen(false)} sx={{ color: 'red' }}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

<DialogContent dividers sx={{ maxHeight: '75vh', overflowY: 'auto' }}>
    <TextField fullWidth label="Exam Title" margin="dense"
      value={newExam.title}
      onChange={e => setNewExam({ ...newExam, title: e.target.value })}
    />
    <TextField fullWidth label="Duration (minutes)" type="number" margin="dense"
      value={newExam.duration_minutes}
      onChange={e => setNewExam({ ...newExam, duration_minutes: e.target.value })} style={{display:'none'}}
    />
    <TextField fullWidth label="Total Marks" type="number" margin="dense"
      value={newExam.total_marks}
      onChange={e => setNewExam({ ...newExam, total_marks: e.target.value })} style={{display:'none'}}
    />
    <TextField fullWidth label="Passing Marks" type="number" margin="dense"
      value={newExam.passing_marks}
      onChange={e => setNewExam({ ...newExam, passing_marks: e.target.value })} style={{display:'none'}}
    />

    <FormControl fullWidth margin="normal" variant="outlined" style={{display:'none'}}>
      <InputLabel id="exam-type-label" >Exam Type</InputLabel>
      <Select
        labelId="exam-type-label"
        label="Exam Type"
        value={newExam.exam_type}
        onChange={e => setNewExam({ ...newExam, exam_type: e.target.value })}
      style={{display:'none'}} >
        <MenuItem value="practice">Practice</MenuItem>
        <MenuItem value="mock">Mock</MenuItem>
        <MenuItem value="final">Final</MenuItem>
      </Select>
    </FormControl>

    <FormControl fullWidth margin="normal" variant="outlined" style={{display:'none'}}>
      <InputLabel id="status-label">Status</InputLabel>
      <Select
        labelId="status-label"
        label="Status"
        value={newExam.status}
        onChange={e => setNewExam({ ...newExam, status: e.target.value })}
      >
        <MenuItem value={true}>Active</MenuItem>
        <MenuItem value={false}>Inactive</MenuItem>
      </Select>
    </FormControl>
  </DialogContent>

  <DialogActions>
    <Button onClick={() => setAddExamModalOpen(false)}>Cancel</Button>
    <Button variant="contained" color="success" onClick={handleAddExamSubmit}>Add Exam</Button>
  </DialogActions>
</Dialog>

{/* calling that add subject modal  */}
      <SubjectModal
        open={addSubjectModalOpen}
        onClose={() => {
          setAddSubjectModalOpen(false);
          setNewSubjectData({ exam_id: '', name: '', code: '', status: 'Active' });
          setCodeManuallyEdited(false);
        }}
        onSubmit={handleAddSubject} // Your function to add a subject
        subjectData={newSubjectData}
        setSubjectData={setNewSubjectData}
        exams={exams}
        generateCode={generateCode}
        codeManuallyEdited={codeManuallyEdited}
        setCodeManuallyEdited={setCodeManuallyEdited}
        title="Add New Subject"
        submitButtonText="Add Subject"
        submitButtonColor="success"
      />

{/* calling that add topic modal */}
      <TopicModal
        open={addTopicModalOpen}
        onClose={() => {
          setAddTopicModalOpen(false);
          setNewTopic({ exam_id: '', subject_id: '', title: '', status: 1 });
        }}
        newTopic={newTopic}
        setNewTopic={setNewTopic}
        exams={exams}
        filteredSubjects={subjects}
        handleAddTopic={handleAddTopic}
      />
    </div>
  );
};

export default FormModalBulk;